import { Button, makeStyles } from '@material-ui/core';
import React, { useEffect, useReducer, useState } from 'react';
import ModulesList from '../../../../components/modules-list/ModulesList';
import {
  ENTERTAINMENT,
  entertainmentModules,
  guestRoomExpModules,
  GUEST_ROOM_EXP,
  hotelServiceModules,
  HOTEL_SERVICES,
  HOTEL_SYSTEMS_TITLES,
} from '../../../../constants/ConfigurationsConst';
import {
  updateEntertainmentModules,
  updateGuestRoomExpModules,
  updateHotelServiceModules,
} from '../../../../utils/IntegrationsAPIUtils';
import { notificationManager } from '../../../../utils/NotificationUtils';
import './../HotelSystems.scss';

const useStyles = makeStyles((theme) => ({
  activeButton: {
    color: '#29E67C',
    margin: '8px 18px',
    borderRadius: '26px',
    border: '2px solid #74E287',
    opacity: 1,
    fontWeight: 600,
    fontSize: '1.2em',
  },
  button: {
    margin: '8px 18px',
    borderRadius: '26px',
    fontWeight: 600,
    fontSize: '1.2em',
    color: '#828282',
  },
  input: {
    display: 'none',
  },
}));

const ModuleListUpdate = (props) => {
  const { onUpdate, savedSelectedModuleList, updateActiveTab, hotelId } = props;
  const classes = useStyles();
  const [activeTab, setActiveTab] = useState(updateActiveTab);
  const [moduleList, setModuleList] = useState(hotelServiceModules);
  const [selectedModules, setSelectedModules] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    savedSelectedModuleList,
  );
  const [hasChanged, setHasChanged] = useState(false);

  useEffect(() => {
    setHasChanged(false);
    switch (activeTab) {
      case HOTEL_SERVICES:
        setModuleList(hotelServiceModules);
        break;
      case GUEST_ROOM_EXP:
        setModuleList(guestRoomExpModules);
        break;

      case ENTERTAINMENT:
        setModuleList(entertainmentModules);
        break;

      default:
        setModuleList(hotelServiceModules);
    }
  }, [activeTab]);

  useEffect(() => {
    const addedList = selectedModules[activeTab].filter(
      ({ module: m1 }) => !savedSelectedModuleList[activeTab].some(({ module: m2 }) => m2 === m1),
    );
    const removedList = savedSelectedModuleList[activeTab].filter(
      ({ module: m1 }) => !selectedModules[activeTab].some(({ module: m2 }) => m2 === m1),
    );
    setHasChanged(addedList.length > 0 || removedList.length > 0);
  }, [selectedModules[activeTab]]);

  const handleAddModule = (moduleObj) => {
    const currModuleList = [...selectedModules[activeTab]];
    const currIndex = currModuleList.findIndex((m) => m.module === moduleObj.key);

    if (currIndex === -1) {
      const savedModuleObj = savedSelectedModuleList[activeTab].find(
        (m) => m.module === moduleObj.key,
      );
      if (savedModuleObj) {
        currModuleList.push(savedModuleObj);
      } else {
        currModuleList.push({
          module: moduleObj.key,
          enabledDevices: {
            webApp: true,
            mobile: false,
            tablet: false,
          },
        });
      }
    } else {
      currModuleList.splice(currIndex, 1);
    }

    setSelectedModules({ [activeTab]: currModuleList });
  };

  const handleUpdate = async () => {
    let res;
    switch (activeTab) {
      case HOTEL_SERVICES:
        res = await updateHotelServiceModules(hotelId, selectedModules.hotelServiceModules);
        break;

      case GUEST_ROOM_EXP:
        res = await updateGuestRoomExpModules(hotelId, selectedModules.guestRoomExpModules);
        break;

      case ENTERTAINMENT:
        res = await updateEntertainmentModules(hotelId, selectedModules.entertainmentModules);
        break;

      default:
    }

    if (res.data) {
      notificationManager('success', 'All selected modules have been activated');
      onUpdate(selectedModules);
    }
  };

  return (
    <div>
      <div className='d-flex mt-4 justify-content-between  align-items-center'>
        <div className='sub-title'>Select Modules</div>
        <div className='d-flex my-2 justify-content-center'>
          {Object.keys(HOTEL_SYSTEMS_TITLES).map((section, i) => (
            <Button
              key={i}
              size='small'
              variant={activeTab === section ? 'outlined' : 'text'}
              className={activeTab === section ? classes.activeButton : classes.button}
              onClick={() => setActiveTab(section)}
            >
              {HOTEL_SYSTEMS_TITLES[section]}
            </Button>
          ))}
        </div>
      </div>
      <div className='row d-flex mt-3'>
        <div className='card shadow module-select'>
          <div className='mx-auto w-75 my-5'>
            <ModulesList
              moduleList={moduleList}
              selectedModules={selectedModules}
              activeTab={activeTab}
              handleAddModule={handleAddModule}
            />
          </div>
          <div className='row mx-2 mt-auto px-4  pb-5 justify-content-center'>
            {hasChanged && (
              <div className='text-center'>
                <Button
                  className='update-btn'
                  size='large'
                  color='primary'
                  variant='contained'
                  onClick={() => handleUpdate()}
                >
                  Update
                </Button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModuleListUpdate;
